import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = localStorage.getItem(AuthService.STORAGE_KEY_TOKEN);
    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
